import { ErrorMessage, Form, Formik } from 'formik';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { Button, Header, Label } from 'semantic-ui-react';
import { addAbortSignal } from 'stream';
import MyTextInput from '../../app/common/form/MyTextInput';
import ModalContainer from '../../app/common/modals/ModalContainer';
import { UserFormValues } from '../../app/models/user';
import { useStore } from '../../app/stores/store';

export default observer(function LoginForm() {
    const usStore = useStore();
    const usNavigate = useNavigate();

    // const [userFormValues, setUserFormValues] = useState<UserFormValues>({ //' nn
    //     email: '',
    //     password: '',
    //     displayName: '',
    //     userName: '',
    // });

    // function handleFormSubmit(userFormValues: UserFormValues) { //' nn
    //     console.log(userFormValues);

    //     usStore.userStore.login(userFormValues).then(() => usNavigate('/activities'));
    //     //usStore.userStore.getUser().then(() => usNavigate('/activities'));

    //     userFormValues.userName = 'userNameTest';
    //     userFormValues.displayName = 'displayNameTest';
    //     //usStore.userStore.register(userFormValues).then(() => usNavigate('/activities'))
    // }

    return (
        <Formik
            initialValues={{email: '', password: '', error: null}} 
            //initialValues={userFormValues} //.
            
            //onSubmit={values => console.log(values)} 
            //onSubmit={values => handleFormSubmit(values)} //.
            //onSubmit={values => usStore.userStore.login(values)} 
            onSubmit={(values , {setErrors}) => usStore.userStore.login(values).catch(err => 
                setErrors({
                    //error: err,
                    //error: 'Invalid email or password', //'o
                    error: err.response.data, //'n ok ok ok
                }),
            )} 
        >
            {({handleSubmit, isSubmitting, errors, isValid, dirty}) => (
                <Form className='ui form' onSubmit={handleSubmit} autoComplete='off'>
                    <Header as='h2' content={`Login to ${usStore.commonStore.appDisplayName}`} color='teal' textAlign='center' />

                    <Header as='h5' content='Demo email: ashraf_qasem@hotmail.com' color='blue' />
                    <MyTextInput placeholder={'ashraf_qasem@hotmail.com'} name={'email'} />

                    <Header as='h5' content='Demo password: Pa$$w0rd' color='blue' />
                    <MyTextInput placeholder={'Pa$$w0rd'} name={'password'} type='password' />

                    <ErrorMessage name='error' render={() => <Label content={errors.error} color='red' basic style={{ marginBottom: 10 }} />} />
                    <Button type='submit' content='Login' positive fluid loading={isSubmitting} disabled={isSubmitting || !isValid || !dirty} />
                </Form>
            )}
        </Formik>
    )
})